import * as Scrivito from "scrivito";

function AddButton({ onClick, title = "Add new Object" }) {
  if (!Scrivito.isInPlaceEditingActive()) {
    return null;
  }
  return (
    <div className="row">
      <div className="col-sm-12">
        <button className="btn btn-primary mb-3 text-white" onClick={onClick}>
          <i className="las la-plus me-2" />
          {title}
        </button>
      </div>
    </div>
  );
}
export default Scrivito.connect(AddButton);
